<template>
  <div class="house-importer-finance-stage-payments-panel" ref="container">
    <app-panel title="Платежи по лицевому счету">
        <div slot="actions" class="house-importer-finance-stage-payments-panel__actions">
          <app-input label="Лицевой счет" v-model="accountNumber" @keydown.enter="getPayments"/>
          <app-button color="success" @click="getPayments">Показать</app-button>
        </div>


      <div class="house-importer-finance-stage-payments-panel__loading-block" v-if="isLoading">
        <div class="block-loading" />
        <div>Получаю платежи...</div>
      </div>
      <div v-else-if="dataLoaded" style="padding: 0 15px;">
        <vs-table :data="payments" hoverFlat class="house-importer-finance-stage-payments-panel__table" no-data-text="Платежей нет">
          <template slot="thead">
            <vs-th>Лицевой счет</vs-th>
            <vs-th>Сумма</vs-th>
            <vs-th>Комиссия</vs-th>
            <vs-th>Всего</vs-th>
            <vs-th>Месяц назначения платежа</vs-th>
            <vs-th>Дата прохождения платежа</vs-th>
            <vs-th style="width: 170px"/>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="`${trIndex}-${tr.id}`" v-for="(tr, trIndex) in data">
              <vs-td>{{tr.account_number}}</vs-td>
              <vs-td>{{tr.amount | numberWithSpaces}}</vs-td>
              <vs-td>{{tr.amount_agency | numberWithSpaces}}</vs-td>
              <vs-td>{{tr.all_amount | numberWithSpaces}}</vs-td>
              <vs-td>
                <app-datepicker v-model="tr.monthyear" class="house-importer-finance-stage-payments-panel__table-datepicker" format="MMMM yyyy" minimum-view="month" @input="tr.isEdit = true"/>
              </vs-td>
              <vs-td>
                <app-datepicker v-model="tr.payment_passage_date" class="house-importer-finance-stage-payments-panel__table-datepicker" @input="tr.isEdit = true"/>
              </vs-td>
              <vs-td>
                <div @click="saveEdit(tr)" v-if="tr.isEdit" class="link-icon" style="white-space: nowrap; text-align: right;">
                  Сохранить изменения
                </div>
                <div v-else-if="tr.isSending" style="white-space: nowrap;  text-align: right;">
                  Сохранение...
                </div>
                <div v-else-if="tr.isEdited && !tr.isSending" style="white-space: nowrap;  text-align: right; color: rgba(var(--app-success), 1)">
                  Сохранено
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

    </app-panel>
  </div>
</template>

<script>
  export default {
    name: "PaymentsPanel",
    props: {
      importInfo: {}
    },
    data(){
      return {
        accountNumber: null,
        isLoading: false,
        dataLoaded: false,
        payments: []
      }
    },
    methods: {
      async getPayments(){
        if(this.accountNumber === null) return false;
        this.$nextTick(() => {
          this.$refs.container.scrollIntoView({block: "start", behavior: "smooth"});
        });

        let params = Object.assign({import_id: this.importInfo.id, account_number: this.accountNumber});
        this.isLoading = true;

        try{
          let {data} = await this.$http.get('import/houses/invoices', {params: params});

          let payments = data.map(payment => {
            payment.monthyear = this.$parseDateFromString(payment.monthyear);
            payment.payment_passage_date = this.$parseDateFromString(payment.payment_passage_date);
            payment.isEdit = false;
            payment.isSending = false;
            payment.isEdited = false;
            return payment;
          });
          this.payments = payments;
        }
        catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.payments = [];
        }
        finally {
          setTimeout(() => {
            this.isLoading = false;
            this.dataLoaded = true;
            this.$nextTick(() => {
              this.$refs.container.scrollIntoView({block: "start", behavior: "smooth"});
            });
          }, 300)
        }
      },
      async saveEdit(tr){
        tr.isSending = true;
        try{
          let body = Object.assign({},{import_id: this.importInfo.id});
          body.invoice_id = tr.id;
          body.payment_passage_date = this.$options.filters.moment(tr.payment_passage_date, 'YYYY-MM-DD');
          body.monthyear = this.$options.filters.moment(tr.payment_passage_date, 'YYYY-MM');
          await this.$http.put('import/houses/invoices', body);
          tr.isEdit = false;
          tr.isEdited = true;
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          tr.isEdit = true;
          tr.isEdited = false;
        }
        finally{
          setTimeout(() => {
            tr.isSending = false;
          }, 300);
        }
      },
      getPaymentsByAccountNumber(accountNumber){
        this.accountNumber = accountNumber;
        this.getPayments();
      }
    }
  }
</script>

<style lang="scss">
  .house-importer-finance-stage-payments-panel{

    &__actions{
      display: flex;
      align-items: flex-end;

      .app-button{
        margin-left: 15px;
      }
    }

    &__table{
      .vs-table--tbody{
        border: none;
        background: #fff;
      }

      .vs-table--thead th{
        padding: 0!important;
        border-bottom: 1px solid rgba(0,0,0,.125);

        .vs-table-text{
          text-align: left;
          position: relative;
          vertical-align: bottom;
          padding: .75rem 10px;
          background: transparent;
          font-size: 12px;
        }
      }

      .vs-table{
        .vs-table--tr:nth-child(2n+1){
          background: #f5f8fa;
        }
      }

      .tr-values td{
        padding: .5rem 10px;
        font-size: 12px;
      }

      .vs-table--pagination{
        justify-content: center;
      }

      &-datepicker{
        width: 120px;

        input{
          background: transparent;
          border: none !important;
          text-decoration: underline;
          font: inherit!important;
          font-size: 12px !important;
          cursor: pointer;
          color: rgba(var(--app-primary), 1);
          padding: 0!important;
          letter-spacing: .3px;
        }
      }
    }

    &__loading-block{
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .block-loading{
        width: 60px;
        height: 60px;
        flex: 0;
        margin-bottom: 20px;
      }
    }

  }
</style>